<template>
    <div class="packageList" style="min-height: 500px;margin-bottom: 200px;">
        <div class="main-container">
            <div class="rule">
                <div class="main-container-head">
                    <ul class="breadcrumb">
                        <!-- <li><a href="javascript:void(0)">酒店预订</a>></li> -->
                        <li> </li>
                    </ul>
                </div>
                <div class="packageList-search">
                    <div class="left">
                        <div class="content-item input">
                            <i class="iconfont icon-lmy-dingwei"></i>
                            <div class="searchAll" @click="isHotCityShow = true;isTypeShow = false;" >{{city}}</div>
                            <HotCity @select="hotCity" :isHotCityShow="isHotCityShow"></HotCity>
                        </div>
                        <div class="content-item input">
                            <i class="iconfont icon-mulu"></i>
                            <div class="searchAll" @click="isTypeShow = true;isHotCityShow = false;" >{{searchType}}</div>
                            <HotCity @select="isType" :isTypeShow="isTypeShow"></HotCity>
                        </div>
                        <div class="content-item">
                            <i class="iconfont icon-search"></i>
                            <input type="text" data-type="searchAll" maxlength="50" placeholder="关键词"
                                   v-model="key" class="searchAll" @input="isHotCityShow = false;isTypeShow = false"/>
                            <i class="iconfont icon-guanbi" v-if="key" @click="key='';"></i>
                        </div>
                    </div>
                    <div class="right">
                        <div class="btn" @click="searchInit()">
                            搜索
                        </div>
                    </div>
                </div>

                <div class="cnhotel-list-top">
                    <div class="cnhotel-filter-result" v-if="!isLogoLoading">
                        为您搜索到
                        <span class="color-orange">{{total}}</span>
                        个度假套餐
                    </div>
                    <div class="cnhotel-filter-result" v-else>正在为您搜索...</div>
                </div>
                <Loading :isLogoLoading="isLogoLoading"></Loading>
                <div class="packageList-box" v-if="packageList">
                    <div class="packageItem" v-for="item in packageList" @click="routeToDetails(item)">
                        <div class="listImg">
                            <div :class="item.Type==1?'productTag':'productTag orange'">
                                <p v-if="item.Type==1">优惠度假</p>
                                <p v-else>超值预售</p>
                            </div>
                            <img v-if="item.ListImg" :src="item.ListImg" class="packageImg" alt="" v-img-error="defaultImg">
                            <img v-else :src="defaultImg">
                            <div class="icon" v-show="item.CityName">
                                <i class="iconfont icon-lmy-dingwei" ></i>
                                 {{item.CityName}}
                            </div>
                        </div>
                        <div class="listPrice">
                            <div class="price">
                            ￥<span class="number">{{item.Price||' XX '}}</span> 起
                            </div>
                            <div>
                                <div class="time" v-if="(dateIntervene(item.SaleStart)<=0)&&item.clockHour&&(item.clockHour<48)">
                                    <span class="on" v-if="item.clockEnd">距结束 :</span>
                                    <span class="under" v-html="item.clockEnd"></span>
                                </div>
                                <div class="time" v-if="dateIntervene(item.SaleStart)>0">
                                    <span class="on" v-if="item.clockStart">距开售 :</span>
                                    <span class="under" v-html="item.clockStart"></span>
                                </div>
                            </div>
                        </div>
                        <div class="listText">
                            <div class="productName">
                                {{item.ProductName}}
                            </div>
                            <div class="productTip">
                                {{item.Tags[0]}}
                            </div>
                        </div>

                    </div>
                </div>
                <Paginate :pageIndex="Page" :pageTotal="Math.ceil(total/PageSize)" @select="pageSelect"
                              v-if="total>10">
                </Paginate>
              
            </div>
        </div>
        <Modal v-show="modal.show" :config="modal" @close="modal.show=false" @ok="modalOK"></Modal>
    </div>
</template>

<script>
import SearchAll from "./../../common/cmpnt/searchAll/SearchAll"; //模糊搜索
import HotCity from "./comm/HotCity.vue"; //热门城市
import DatePicker from "./comm/datePicker.vue"; //日期(单选)
import Paginate from "./../../common/cmpnt/paginate/paginate.vue"; //分页
import Loading from "./../../common/cmpnt/Loading/Loading.vue"; //缓冲
import Modal from "./../../common/cmpnt/Modal/modal.vue"; //跳转提示框
import defaultPackageImg from "../../assets/img/defaultPackage.jpg";

export default {
  name: "PackageList",
  components: {
    Paginate,
    DatePicker,
    SearchAll,
    HotCity,
    Loading,
    Modal
  },
  data: function() {
    return {
      defaultImg: defaultPackageImg,
      isModalShow: false,
      isHotCityShow: false,
      isTypeShow:false,
      isLogoLoading: true,
      city: "深圳",
      cityID: "2003",
      searchTypeID: 0,
      searchType: "全部类型",
      hotCityList:[],
      key: "",
      total: 0,
      list: "",
      packageList: [],
      dateArr: [],
      Page: 1,
      PageSize: 10,
      modal: {
        show: false,
        config: {}
      },
      modalType: "book"
    };
  },
  created: function() {},
  watch: {},
  mounted() {
    document.title='度假预订---订房易';
    this.initData();
    this.getHotCity()
  },

  methods: {
    modalOK() {
      if (this.modalType == "book") {
        this.$router.push("/hotelBook");
      } else {
        this.routeToDetails(this.currentHotelInfo);
      }
    },
    //打开详情
    routeToDetails(item) {
      window.open("#/packageDetails?ProductId=" + item.ProductId, "_blank");
    },

    //条件搜索
    searchInit() {
      this.list = "";
      this.Page = 1;
      this.total = 0;
      this.initData();
    },
    hotCity(obj) {
      this.isHotCityShow = false;
      if (obj&&obj.ID) {
        this.cityID = obj.ID;
        this.city = obj.Name;
      }
      
    },

    isType(index) {
      this.isTypeShow = false;
      if (index>=0&&index<3) {
        this.searchTypeID = index
        this.searchType = index==0?'全部类型':(index==1?'日历套餐':'预约套餐')
      }
      
    },

    // 获取热门城市
    getHotCity() {
      var that = this;
      that
        .getRequest({
          url: that.Api.getPackageHotCity
        })
        .then(res => {
          if (res && res.IsSuccess && res.Result.length > 0) {
            that.hotCityList = res.Result;
            that.dao.set('getPackageHotCity',JSON.stringify(res.Result));
            that.$nextTick(() => {
              if(localStorage.getItem('lang')=='t'){
                that.$zh_tran(localStorage.getItem('lang'))
              }         
            })
          } 
        });
    },

    //获取度假数据
    initData() {
      var that = this;
      var params = {
          Page: that.Page,
          PageSize: that.PageSize,
          Name: that.key,
          CityID: that.cityID,
          Type: "",
        };
      that.isLogoLoading = true;
      if(that.searchTypeID==1||that.searchTypeID==2){
        params.Type = that.searchTypeID
      }else{
        params.Type = ''
      }
      that
        .postRequest({
          url: that.Api.getPackageList,
          params: params
        })
        .then(res => {
            that.isLogoLoading = false;
          if (res && res.IsSuccess && res.Result.length > 0) {
            that.total = res.Total;
            that.packageList = res.Result;
            that.initClock(res.Result);
            that.$nextTick(() => {
              if(localStorage.getItem('lang')=='t'){
                that.$zh_tran(localStorage.getItem('lang'))
              }         
            })
          } else {
            that.packageList = "";
            that.total = 0;
            // this.error({
            //   title: "提示",
            //   content: res.Msg || "未获取到相关信息！"
            // });
          }
        });
    },

    initClock(list) {
      for (var i = 0; i < list.length; i++) {
        this.timeLoop(list[i], list[i].SaleStart, list[i].SaleEnd);
      }
    },
    timeLoop(item, start, end) {
      var num = 1;
      var that = this;
      var end = that.dateIntervene(end);
      var start = that.dateIntervene(start);
      var time = setInterval(function() {
        num++;
        if (num >= end) {
          clearInterval(time);
        } else {
          var hour = that.betDateH(end - num);
          that.$nextTick(function() {
            if (start > 0) {
              that.$set(item, "clockStart", that.betDateFomate(start - num));
            } else if (start <= 0 && hour < 48) {
              that.$set(item, "clockHour", hour);
              that.$set(item, "clockEnd", that.betDateFomate(end - num));
            }
          });
        }
      }, 1000);
    },
    betDateH(time) {
      return Math.floor(time / 60 / 60);
    },
    dateIntervene(date) {
      var s1 = new Date().getTime();
      var s2 = new Date(date).getTime();
      return parseInt((s2 - s1 > 0 ? s2 - s1 : 0) / 1000);
    },
    betDateFomate(time) {
      var d, h, m, s;
      if (time >= 0) {
        d = Math.floor(time / 60 / 60 / 24);
        h = Math.floor((time / 60 / 60) % 24);
        m = Math.floor((time / 60) % 60);
        s = Math.floor(time % 60);
      }

      var intv =
        "<span>" +
        d +
        "</span> 天 <span>" +
        (h < 10 ? "0" + h : h) +
        "</span> : <span>" +
        (m < 10 ? "0" + m : m) +
        "</span> : <span>" +
        (s < 10 ? "0" + s : s);

      return intv;
    },

    // 选择页数
    pageSelect(val) {
      this.total = 0;
      this.list = [];
      this.Page = val;
      this.initData();
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/package/list.vue